<script setup lang="ts">
import RichTextEditor from '@/components/editors/RichTextEditor.vue';

defineProps<{ modelValue: string }>();

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void;
  (event: 'save'): void;
}>();
</script>

<template>
  <section>
    <div class="mb-3 flex flex-wrap items-start justify-between gap-3">
      <div>
        <p class="text-base font-semibold text-foreground">Description</p>
        <p class="text-sm text-muted-foreground">Start with a short summary, then add bullets, links, decisions, or handoff notes.</p>
      </div>
      <span class="rounded-full border border-border/70 bg-background/80 px-3 py-1 text-xs font-medium text-muted-foreground">
        Rich text supported
      </span>
    </div>
    <RichTextEditor
      :model-value="modelValue"
      @update:model-value="value => emit('update:modelValue', value)"
      @blur="emit('save')"
    />
  </section>
</template>
